module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/007-nicaragua-7d5ea585e7e86c955dfd89ce6aaa7752.svg";